export default "__VITE_ASSET__BMxOWipI__"